import { motion } from "framer-motion";

import { cn } from "../lib/utils";

const VARIANTS = {
  fadeUp: {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1],
    },
    viewport: { amount: 0.2, margin: "0px 0px -10% 0px", once: true },
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.9 },
    whileInView: { opacity: 1, scale: 1 },
    transition: {
      duration: 0.5,
      ease: [0.16, 1, 0.3, 1],
    },
    viewport: { amount: 0.2, margin: "0px 0px -10% 0px", once: true },
  },
};

export function ScrollReveal({
  children,
  className,
  variant = "fadeUp",
  delayMs = 0,
}) {
  const base = VARIANTS[variant];

  return (
    <motion.div
      {...base}
      transition={{
        ...(base.transition ?? {}),
        delay: delayMs / 1000,
      }}
      className={cn(className)}
    >
      {children}
    </motion.div>
  );
}
